<template>
  <b-row v-if="showMore">
    <b-col>
      <b-row>
        <b-col>
          <validation-observer
            ref="validacaoChecklist"
            :disabled="true"
          >
            <b-table
              v-if="items.length > 0"
              :items="items"
              :fields="colunasInner"
              bordered
              hover
              class="tabela-checklist"
            >
              <template #cell(pergunta)="{ item }">
                <span
                  class="limite-texto"
                  @click="abrirDescricaoComplementar(item)"
                >{{ item.obrigatorioRegra ? '* ' : '' }}{{ item.descricao }}</span>
              </template>
              <template #cell(resposta)="{ item }">
                <span v-if="item.tipoRegra === 'numerico' && !item.emEdicao">{{ item.resposta }}</span>
                <validation-provider
                  v-else-if="item.tipoRegra === 'numerico' && item.emEdicao"
                  #default="{ errors }"
                  :rules="(item.obrigatorioRegra && !geradoProposta && responsavelAResponder == 'gerenteresponsavel')? 'required' : ''"
                  :vid="item.id > 0 ? item.id.toString() : getCodeValidation()"
                >
                  <b-input
                    v-model="item.resposta"
                    :min="0"
                    type="number"
                    :placeholder="'Responda aqui'"
                    @keypress="isNumberValid($event)"
                    @input="calcularValorNumerico($event, item)"
                  />
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >Campo obrigatório</small>
                </validation-provider>
                <span
                  v-else-if="item.tipoRegra === 'textolivre' && !item.emEdicao"
                  class="limite-texto"
                  @click="showRespostaCompleta(item)"
                >{{ item.resposta }}</span>
                <validation-provider
                  v-else-if="item.tipoRegra === 'textolivre' && item.emEdicao"
                  #default="{ errors }"
                  :rules="(item.obrigatorioRegra && !geradoProposta && responsavelAResponder == 'gerenteresponsavel')? 'required' : ''"
                  :vid="item.id > 0 ? item.id.toString() : getCodeValidation()"
                >
                  <b-input
                    v-model="item.resposta"
                    type="text"
                    :placeholder="'Responda aqui'"
                  />
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >Campo obrigatório</small>
                </validation-provider>
                <span v-else-if="item.tipoRegra === 'listasuspensa' && !item.emEdicao && !item.outrosSelecionado">{{ item.resposta }}</span>
                <validation-provider
                  v-else-if="item.tipoRegra === 'listasuspensa' && item.emEdicao"
                  #default="{ errors }"
                  :rules="(item.obrigatorioRegra && !geradoProposta && responsavelAResponder == 'gerenteresponsavel')? 'required' : ''"
                  :vid="item.id > 0 ? item.id.toString() : getCodeValidation()"
                >
                  <v-select
                    v-model="item.resposta"
                    :options="optionsDescricao(item)"
                    :placeholder="'Selecione a resposta'"
                    :clearable="false"
                    @input="calcularValorLista($event, item)"
                  />
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >Campo obrigatório</small>
                </validation-provider>
                <div
                  v-else-if="item.tipoRegra === 'caixaselecao' && !item.emEdicao"
                  @click="showRespostaCompleta(item)"
                >
                  <div
                    v-for="(resp, $index) in item.listaRespostas"
                    :key="$index"
                    class="mr-50 respostas-badge"
                  >
                    <span
                      class="badge badge-outline-primary link"
                      style="font-size: 10px"
                    >{{ getText(resp, item) }}</span>
                  </div>
                </div>
                <validation-provider
                  v-else-if="item.tipoRegra === 'caixaselecao' && item.emEdicao"
                  #default="{ errors }"
                  :rules="(item.obrigatorioRegra && !geradoProposta && responsavelAResponder == 'gerenteresponsavel')? 'required' : ''"
                  :vid="item.id > 0 ? item.id.toString() : getCodeValidation()"
                >
                  <v-select
                    v-model="item.listaRespostas"
                    :options="optionsDescricao(item)"
                    :multiple="true"
                    :placeholder="'Selecione uma ou mais respostas'"
                    @input="calcularValorCaixa($event, item)"
                  />
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >Campo obrigatório</small>
                </validation-provider>
                <div
                  v-else-if="item.tipoRegra === 'tags' && !item.emEdicao"
                  @click="showRespostaCompleta(item)"
                >
                  <div
                    v-for="(resp, $index) in item.listaRespostas"
                    :key="$index"
                    class="mr-50 respostas-badge"
                  >
                    <span
                      class="badge badge-outline-primary link"
                      style="font-size: 10px"
                    >{{ formatCnpjResposta(resp) }}</span>
                  </div>
                </div>
                <validation-provider
                  v-if="item.tipoRegra === 'tags' && item.emEdicao"
                  #default="{ errors }"
                  :rules="(item.obrigatorioRegra && !geradoProposta && responsavelAResponder == 'gerenteresponsavel')? 'required' : ''"
                  :vid="item.id > 0 ? item.id.toString() : getCodeValidation()"
                >
                  <multi-cnpj-input
                    v-model="item.listaRespostas"
                  />
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >Campo obrigatório</small>
                </validation-provider>
                <validation-provider
                  v-if="(item.tipoRegra === 'listasuspensa' || item.tipoRegra === 'caixaselecao') && (item.emEdicao) && (item.outrosSelecionado)"
                  #default="{ errors }"
                  :rules="(item.outrosSelecionado)? 'required' : ''"
                  :vid="getCodeValidation()"
                >
                  <b-input
                    v-model="item.complementoOutros"
                    :placeholder="'Complemento'"
                    class="mt-50"
                  />
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >Campo obrigatório</small>
                </validation-provider>
                <span
                  v-else-if="item.tipoRegra === 'listasuspensa' && !item.emEdicao && item.outrosSelecionado"
                  @click="showRespostaCompleta(item)"
                >{{ item.complementoOutros }}</span>
              </template>
              <template #cell(valor)="{ item }">
                <span v-if="item.valor">{{ item.valor | converteValor }}</span>
                <span v-else />
              </template>
              <template #cell(acoes)="{ item }">
                <b-row style="margin-left: 0px;">
                  <div>
                    <b-btn
                      v-if="!item.emEdicao"
                      pill
                      variant="none"
                      style="padding:0.4rem;"
                      class="btn-outline-primary mr-50"
                      :disabled="(responsavelAResponder == 'pessoaresponsavel' && geradoProposta)
                        || (responsavelAResponder == 'gerenteresponsavel' && dataProposta !== '') || (item.automatico)"
                      @click="editarServico(item)"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-btn>

                    <b-btn
                      v-if="item.emEdicao"
                      v-b-tooltip.hover
                      b-btn
                      title="Salvar"
                      pill
                      variant="none"
                      style="padding:0.4rem;"
                      class="btn-outline-primary mr-50"
                      @click="salvarServico(item)"
                    >
                      <feather-icon icon="CheckIcon" />
                    </b-btn>
                  </div>
                  <anexo-item-check-list
                    v-if="item.tipoRegra !== 'tags'"
                    :existe-anexo="item.nomeArquivo != null && item.nomeArquivo != ''"
                    :gerado-proposta="geradoProposta"
                    :proposta-id="propostaId"
                    :item-id="item.id > 0 ? item.id.toString() : item.code"
                    :nome-arquivo="item.nomeArquivo"
                    :desabilitar="responsavelAResponder == 'pessoaresponsavel'"
                    @add-file="adicionarArquivoItem($event, item)"
                    @remover-arquivo="removerArquivoItem(item)"
                  />
                  <info-checklist
                    :item-id="item.id > 0 ? item.id.toString() : item.code"
                    :item="item"
                  />
                </b-row>
              </template>
              <template #table-caption>
                <div style="display: flex;justify-content: space-between;">
                  <div>
                    <span style="font-size: 12px;">* Campos obrigatórios</span>
                  </div>
                  <div class="valor-total-checklist">
                    <strong>Valor checklist: {{ valorCheck | converteValor }}</strong>
                  </div>
                </div>
              </template>
            </b-table>
          </validation-observer>

          <!--Descrição e Resposta completa-->
          <b-modal
            ref="descricaoComplementar"
            size="sm"
            title="Pergunta e descrição complementar"
            title-class="descricao-complementar"
            hide-footer
            centered
          >
            <p v-if="itemSelecionado && itemSelecionado.descricao">
              <strong>Pergunta: </strong>{{ itemSelecionado.descricao }}</p>
            <p v-if="itemSelecionado && itemSelecionado.complementoRegra">
              {{ itemSelecionado.complementoRegra }}</p>
            <p v-if="itemSelecionado && itemSelecionado.automatico">
              *Observação: essa pergunta e sua resposta foi vinculada de forma automática pelo sistema, validando a seleção do campo "Somente filial?" opção "Não".
            </p>
          </b-modal>

          <b-modal
            ref="respostaCompleta"
            size="sm"
            title="Resposta"
            hide-footer
            centered
            @hide="itemSelecionado = null"
          >
            <p
              v-if="itemSelecionado && (itemSelecionado.resposta && itemSelecionado.resposta !== '')"
            >
              {{ itemSelecionado.outrosSelecionado ? itemSelecionado.complementoOutros : itemSelecionado.resposta }}</p>
            <div
              v-for="(item) in itemSelecionado.listaRespostas"
              v-else-if="itemSelecionado && itemSelecionado.listaRespostas && itemSelecionado.tipoRegra === 'caixaselecao'"
              :key="item"
            >
              <p>{{ getText(item, itemSelecionado) }}</p>
            </div>
            <div
              v-for="(item) in itemSelecionado.listaRespostas"
              v-else-if="itemSelecionado && itemSelecionado.listaRespostas"
              :key="item"
            >
              <p v-if="itemSelecionado.tipoRegra === 'tags'">
                {{ formatCnpjResposta(item) }}
              </p>
              <p v-else>
                {{ item }}
              </p>
            </div>
          </b-modal>

          <modal-justificativa
            id="'modalJustificativa'"
            :ref="'modalJustificativa'"
            @cancelar="cancelar()"
            @confirmar="confirmar($event)"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">

.descricao-complementar {
  font-size: 15px;
}

.tabela-checklist {
  th {
    background-color: #e1e1e1 !important;
  }

  th,
  td {
    padding: 0.5rem 0.2rem;
  }

  .table-hover {
    tr {
      cursor: default !important;
    }
  }

  .limite-texto {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .valor-total-checklist {
    // float: right;
    // width: 25.5rem;
    font-size: 16px;
    color: #5e5873;
  }
}

.limite-resposta {
  width: 300px !important;
  max-width: 300px !important;
}

.limite-pergunta {
  width: 500px !important;
  max-width: 500px !important;
}

.respostas-badge {
  display: inline-flex;
  align-self: center;
  height: fit-content;

  .badge-outline-primary {
    border: 1px solid var(--primary) !important;
    background-color: transparent;
    color: var(--primary) !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(13rem);
  }
}
</style>

<script>
import { generateCode, isNumber } from '@core/utils/utils'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'

export default {
  name: 'TabelaChecklist',
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
    AnexoItemCheckList: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/checklist-proposta/shared/components/AnexoItemCheckList.vue'),
    InfoChecklist: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/checklist-proposta/shared/components/InfoChecklist.vue'),
    MultiCnpjInput: () => import('@/shared/components/multi-cnpj-input/MultiCnpjInput.vue'),
    ModalJustificativa: () => import('@/shared/components/modal-justificativa/ModalJustificativa.vue'),
  },
  props: {
    propostaId: {
      type: Number,
      default: 0,
    },
    geradoProposta: {
      type: Boolean,
      default: false,
    },
    responsavelAResponder: {
      type: String,
      default: '',
    },
    dataProposta: {
      type: String,
      default: '',
    },
    showMore: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [Array],
      default: () => [],
    },
    valorChecklist: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      colunasInner: [
        {
          key: 'pergunta', label: 'Perguntas', thStyle: 'width: 500px', tdClass: 'limite-pergunta',
        },
        {
          key: 'resposta', label: 'Respostas', thStyle: 'width: 300px', tdClass: 'limite-resposta',
        },
        { key: 'valor', label: 'Valor', thStyle: 'width: 120px' },
        {
          key: 'acoes', label: 'Ações', thStyle: 'width: 65px', tdClass: 'text-center',
        },
      ],
      items: [],
      itemSelecionado: null,
      valorCheck: 0,
    }
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.items = value
      }
    },
    valorChecklist(value, oldValue) {
      if (value !== oldValue) {
        this.valorCheck = value
      }
    },
  },
  created() {
    this.items = this.value
    if (this.items.length > 0) {
      this.valorTotal()
    }
  },
  methods: {
    isNumberValid(event) {
      isNumber(event)
    },
    getText(resp, item) {
      const ser = item.servicosItems.find(fin => fin.descricao === resp)
      if (ser) {
        const text = ser.outros ? item.complementoOutros : resp
        return text
      }
      return resp
    },
    getCodeValidation() {
      return generateCode()
    },
    adicionarArquivoItem(file, item) {
      // eslint-disable-next-line no-param-reassign
      item.nomeArquivo = file.id
      // eslint-disable-next-line no-param-reassign
      item.arquivoAnexo = file
    },
    removerArquivoItem(item) {
      // eslint-disable-next-line no-param-reassign
      item.nomeArquivo = null
      // eslint-disable-next-line no-param-reassign
      item.arquivoAnexo = null
    },
    showRespostaCompleta(item) {
      this.itemSelecionado = item
      this.$refs.respostaCompleta.show()
    },
    abrirDescricaoComplementar(item) {
      this.itemSelecionado = item
      this.$refs.descricaoComplementar.show()
    },
    salvarServico(item) {
      if (!item.obrigatorioRegra || (item.obrigatorioRegra && ((item.listaRespostas && item.listaRespostas.length > 0) || (item.resposta && item.resposta !== '')))) {
        // eslint-disable-next-line no-param-reassign
        item.emEdicao = false
      } else {
        this.$erro('Campo obrigatório.')
      }
    },
    editarServico(item) {
      if (this.responsavelAResponder === 'pessoaresponsavel') {
        this.itemSelecionado = item
        this.$refs.modalJustificativa.show()
      } else {
        // eslint-disable-next-line no-param-reassign
        item.emEdicao = true
      }
    },
    cancelar() {
      this.$refs.modalJustificativa.hide()
    },
    confirmar(mensagem) {
      const justSemEspaco = mensagem.replace(/\s+/g, '')
      if (!mensagem || justSemEspaco.length < 10) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: !mensagem ? 'A justificativa para a alteração é obrigatória.' : 'A justificativa deve ter no mínimo 10 caracteres!',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } else {
        const item = this.items.find(find => find.id === this.itemSelecionado.id)
        item.justificativa = mensagem
        item.emEdicao = true
        this.$refs.modalJustificativa.hide()
      }
    },
    calcularValorNumerico(res, item) {
      if (item.servicosItems[0].servico) {
        // eslint-disable-next-line no-param-reassign
        item.valor = item.servicosItems[0].valorAuditarServico * parseFloat(res, 10)
      }
      this.valorTotal()
    },
    calcularValorLista(res, item) {
      const servico = item.servicosItems.find(fin => fin.descricao === res)
      // eslint-disable-next-line no-param-reassign
      item.valor = servico.valorAuditarServico

      if (servico.outros) {
        // eslint-disable-next-line no-param-reassign
        item.outrosSelecionado = true
      } else {
        // eslint-disable-next-line no-param-reassign
        item.complementoOutros = null
        // eslint-disable-next-line no-param-reassign
        item.outrosSelecionado = false
      }
      this.valorTotal()
    },
    calcularValorCaixa(resps, item) {
      let valorTotal = 0
      const respostaFinal = []
      let achouSelecaoOutros = false
      for (let i = 0; i < resps.length; i += 1) {
        const servico = item.servicosItems.find(fin => fin.descricao === resps[i])
        if (servico.outros) {
          achouSelecaoOutros = true
        }
        valorTotal += servico.valorAuditarServico
        respostaFinal[i] = servico.descricao
      }

      if (achouSelecaoOutros) {
        // eslint-disable-next-line no-param-reassign
        item.outrosSelecionado = true
      } else {
        // eslint-disable-next-line no-param-reassign
        item.complementoOutros = null
        // eslint-disable-next-line no-param-reassign
        item.outrosSelecionado = false
      }

      // eslint-disable-next-line no-param-reassign
      item.valor = valorTotal
      // eslint-disable-next-line no-param-reassign
      item.listaRespostas = respostaFinal

      this.valorTotal()
    },
    optionsDescricao(item) {
      const opcoesSemDesc = []
      for (let i = 0; i < item.servicosItems.length; i += 1) {
        opcoesSemDesc[i] = item.servicosItems[i].descricao
      }
      return opcoesSemDesc
    },
    valorTotal() {
      this.valorCheck = 0
      for (let i = 0; i < this.items.length; i += 1) {
        if (this.items[i].valor) {
          this.valorCheck += this.items[i].valor
        }
      }
      this.$emit('valor-checklist', this.valorCheck)
    },
    formatCnpjResposta(value) {
      return value.replaceAll(',', ' - ')
    },
  },
}
</script>
